import { createApp } from "vue";
import { createPinia } from "pinia";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as FontAwesomeYauty from './utils/FontAwesomeYauty.js';
import { installToaster } from 'maz-ui'
import { popoverr } from './utils/BootstrapDirectives.js';
import { Popover } from 'bootstrap'
import { i18n } from './utils/i18n.js';
import VueDatePicker from '@vuepic/vue-datepicker';
import App from "./App.vue";
import router from "./router";
import LocalStorage from '@/controller/LocalStorage.js';
import 'maz-ui/styles' 
import "bootstrap";
import './index.css';
import './styles/commons.scss';
import './styles/theme.css';
import './styles/colors.scss';
import './styles/variables.scss';
import '@vuepic/vue-datepicker/dist/main.css';
import '@/styles/global-filters.scss';

// DEFAULT OPTIONS
const toasterOptions = {
    position: 'bottom-right',
    timeout: 10_000,
    persistent: false,
  };
  
const app = createApp(App);

//Afegim el usercolor com a variable global per a fer servir en tots els css si convé
function applyUserColorVar(){
  const color = LocalStorage.getColor() || '#e5e7eb';
  document.documentElement.style.setProperty('--user-color', color);
}
applyUserColorVar();

// L'actualitzem si l'usuari el canvia
window.addEventListener('storage', (e)=>{
  if(e.key === 'yautyBranding') applyUserColorVar();
});
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('VueDatePicker', VueDatePicker);
app.directive('popoverr', popoverr);
app.use(installToaster, toasterOptions);
// app.directive('vTooltip', yautyTooltip);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.mount("#app"); 